export enum OperacionCapitalMarketsFields  {
  CodPais= 'codPais',
  NombrePais= 'nombrePais',
  CodEstado= 'codOperacionCapitalMarketsEstado',
  DescEstado= 'descOperacionCapitalMarketsEstado',

  EmisorPreAprobado= 'emisorPreAprobado',
  SectorPrivado= 'sectorPrivado',
  Underwriting= 'underwriting',
  SuperaLimitesUnderwriting= 'superaLimitesUnderwriting',
  Limites= 'limites',

  Detalle = 'detalle',

  FechaAlta= 'fechaAlta',
  IdUsuarioAlta= 'idUsuarioAlta',
  BitEnvio= 'enviar',
  PermiteEditar= 'permiteEditarOperacion',
  PermiteEliminar= 'permiteEliminarOperacion',
  NombreUsuarioAlta= 'nombreUsuarioAlta',
  ApellidoUsuarioAlta= 'apellidoUsuarioAlta',
  MailUsuarioAlta= 'mailUsuarioAlta'
}

export enum OperacionCapitalMarketsDetalleFields {
  Emisor = 'emisor',
  Transaccion = 'transaccion',
  ValorNominal = 'valorNominal',
  Moneda = 'moneda',
  Plazo = 'plazo',
  Amortizacion = 'amortizacion',
  FEE = 'FEE',
  Colocadores = 'colocadores',
  Rating = 'rating',
  DestinoDeFondos = 'destinoDeFondos',
  Bridge = 'bridge',
  Underwriting = 'underwriting',
  Nota = 'nota',


  LendingDeudor = 'lendingDeudor',
  LendingAcreedor = 'lendingAcreedor',
  LendingMoneda = 'lendingMoneda',
  LendingMonto = 'lendingMonto',
  LendingDestino = 'lendingDestino',
  LendingPlazoDisponibilidad = 'lendingPlazoDisponibilidad',
  LendingPlazo = 'lendingPlazo',
  LendingAmortizacion = 'lendingAmortizacion',
  LendingTasaInteres = 'lendingTasaInteres',
  LendingFrecuenciaInteres = 'lendingFrecuenciaInteres',
  LendingGarantias = 'lendingGarantias',
  LendingComision = 'lendingComision',
  LendingPrecancelacion = 'lendingPrecancelacion',
  LendingCovenants = 'lendingCovenants',
  LendingLey = 'lendingLey',
  LendingFechaEjecucion = 'lendingFechaEjecucion',
  LendingOtros = 'lendingOtros',
}



export enum FormOperacionCapitalMarketsDetalleFields {
  ListaDestinoDeFondos = 'auxListaDestinoDefondos',
  ListaAmortizacion = 'auxListaAmortizacion'
}